module.exports = __webpack_public_path__ + "static/media/about.6816b304.png";